import { render, staticRenderFns } from "./nc-search.vue?vue&type=template&id=3e976621"
import script from "./nc-search.vue?vue&type=script&lang=js"
export * from "./nc-search.vue?vue&type=script&lang=js"
import style0 from "./nc-search.vue?vue&type=style&index=0&id=3e976621&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports